import React, { createContext, useEffect, useState } from 'react';
import { Osc } from '../types/Osc';


interface RegisterData {
  osc: Osc | undefined
  setOsc: React.Dispatch<React.SetStateAction<Osc | undefined >>
  setStep: React.Dispatch<React.SetStateAction< number >>
  step:number
}

const RegisterOscContext = createContext<RegisterData>({} as RegisterData);

export const RegisterProvider: React.FC = ({ children }) => {

  const [osc, setOsc] = useState<Osc|undefined>()
  const [step,setStep] = useState<number>(1)

  useEffect(()=>{
      
  })

  
  return (
    <>
    <RegisterOscContext.Provider value={{ osc , setOsc , step , setStep  }}>
        {children}
    </RegisterOscContext.Provider>
    </>
  );
};


export default RegisterOscContext;